import { Button, Col, Row, Select } from "antd";
import React from "react";
import { motivoIncidenciaInternaOpciones } from "../../../../constants/cons";
import { useIncidenciaInternaForm } from "./useIncidenciaInternaForm";

export const IncidenciaInterna = () => {
  const { body, handleChange, handleSubmit } = useIncidenciaInternaForm();

  return (
    <Row gutter={5} align="bottom">
      <Col span={16}>
        <div className="inputLabel">Incidencia Interna</div>
        <Select
          onChange={handleChange}
          value={body.motivoIncidencia}
          size="small"
          style={{ width: "100%" }}
          options={motivoIncidenciaInternaOpciones}
        />
      </Col>
      <Col span={8}>
        <Button onClick={handleSubmit} size="small" type="primary">
          Agregar
        </Button>
      </Col>
    </Row>
  );
};
